/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import DefaultModal from './DefaultModal';
import { SnackbarProvider } from 'notistack';

import Styles from '../../css/modals/CreateCommentModal.module.css';
import CreateCommentForm from '../../components/forms/CreateCommentForm';
import { useCommunicationContext } from '../../contexts/CommunicationContext';
import { useLoanContext } from '../../contexts/LoanContext';
import { useViewingContext } from '../../contexts/ViewingContext';

function CreateCommentModal() {
  const { creating } = useCommunicationContext();
  const { isServicerView } = useViewingContext();

  const { loanNumber } = useLoanContext();
  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={2500}
      preventDuplicate
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      {isServicerView && loanNumber && creating && (
        <div className={Styles.createcommentmodal}>
          <CreateCommentForm />
        </div>
      )}
    </SnackbarProvider>
  );
}

export default CreateCommentModal;
